import { render, staticRenderFns } from "./SettingsAddressbookShare.vue?vue&type=template&id=35b94a5a&scoped=true&"
import script from "./SettingsAddressbookShare.vue?vue&type=script&lang=js&"
export * from "./SettingsAddressbookShare.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAddressbookShare.vue?vue&type=style&index=0&id=35b94a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b94a5a",
  null
  
)

export default component.exports